import { HostListener, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export const paths: string[] = ['comdica', 'legislacao', 'prestacao-contas', 'calendario-reunioes', 'contato']

@Injectable({
  providedIn: 'root'
})
export class ScreenService {

  isDesktop?: boolean;
  size!: number;

  constructor() { }

  @HostListener('windows:resize')
  isScreenDesktop() {
    this.size = window.innerWidth;
    if(this.size >= 1024) this.isDesktop = true;
    else this.isDesktop = false;
  }

  private navigation = new Subject<number>();
  emitedValue$ = this.navigation.asObservable();
  emitValue(value: number) {
    this.navigation.next(value);
  }
}
